import { useCallback } from 'react';

import { useFormPrompt } from 'hooks';

import { useFormContext } from '../forms/orderForm';
import { useOrderContext } from '../providers/OrderProvider';

export const useToggleEditable = () => {
  const { onDisableEdit, onEnableEdit } = useOrderContext();
  const { readOnly, setReadOnly } = useFormContext();
  const { confirmIsChanged } = useFormPrompt();

  const disableEditable = useCallback(() => {
    const callback = () => setReadOnly(true);
    return confirmIsChanged(() => onDisableEdit(callback));
  }, [confirmIsChanged, onDisableEdit, setReadOnly]);

  const enableEditable = useCallback(() => {
    onEnableEdit(() => setReadOnly(false));
  }, [onEnableEdit, setReadOnly]);

  return {
    editable: !readOnly,
    disableEditable,
    enableEditable,
  };
};
